import { etatQrCodes, type EtatQrInput } from '../../lib/etat-app';
import { Badge } from '../ui';

/**
 * Bloc commun à l'en-tête de la fiche et aux cartes de la liste : acheteur mis en avant,
 * eticket et état des QR codes vu par l'app.
 */
export default function ResumeCommande({
  commande,
  qrDelivres,
  now,
}: {
  commande: EtatQrInput & { nom: string; prenom: string; eticket: boolean };
  qrDelivres: boolean;
  /** Heure serveur (en-tête `Date`) : c'est elle que l'app utilise pour le dévoilage. */
  now: Date;
}) {
  return (
    <>
      <div className="mt-4">
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-outline-variant">Acheteur</p>
        <p className="text-xl/7 font-bold text-white">
          {commande.prenom} {commande.nom}
        </p>
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <Badge variant={commande.eticket ? 'success' : 'outline'}>{commande.eticket ? 'eticket' : 'non eticket'}</Badge>
        <span className="text-xs/4 font-semibold text-white">{etatQrCodes(commande, qrDelivres, now)}</span>
      </div>
    </>
  );
}
